export default {
  nash: {
    fern: {
      100: '#F3F6F1',
      600: '#50823B',
      700: '#385B29',
    },
    wheat: {
      50: '#FDFCF9',
    },
    purple: {
      50: '#FAF7F9',
      100: '#F5F0F3',
      200: '#E6D7E0',
      300: '#C09BB1',
      400: '#9A6184',
      500: '#803663',
      550: '#673955',
      600: '#471132',
    },
    sizing: {
      space: {
        'space-0': '0rem',
        'space-025': '0.25rem',
        'space-050': '0.5rem',
        'space-075': '0.75rem',
        'space-100': '1rem',
        'space-125': '1.25rem',
        'space-150': '1.5rem',
        'space-175': '1.75rem',
        'space-200': '2rem',
        'space-250': '2.5rem',
        'space-300': '3rem',
        'space-400': '4rem',
        'space-450': '4.5rem',
        'space-500': '5rem',
        'space-600': '6rem',
      },
    },
    mustard: {
      100: '#FDF2DA',
      650: '#BF8600',
    },
    neutral: {
      100: '#F9F9FB',
      200: '#F2F1F5',
      300: '#E3E2E7',
      400: '#D7D5DD',
      500: '#C2BECA',
      600: '#98959E',
      700: '#75717E',
      800: '#534E5E',
      900: '#1F1D24',
      '000': '#FFFFFF',
    },
    tigerlily: {
      100: '#FFF2F0',
      800: '#BD5144',
      900: '#8E3D33',
    },
    midnightBlue: {
      100: '#EEF4FD',
      700: '#313F71',
    },
  },
}
